module.exports = __webpack_public_path__ + "assets/hot.d0cc0673.svg";